<template>
  <div>
    <p>This method should be used to answer callback triggers only.</p>
    <Message :text="data.text" @updateMessage="data.text=$event"></Message>
    <div class="form-check">
      <label class="form-check-label">
        <input type="checkbox" class="form-check-input" v-model="data.show_alert" maxlength="200">
        <h6>Show Alert</h6>
      </label>
    </div>
  </div>
</template>


<script>
import Message from '@/components/tasks/fields/Message.vue'



export default {
  name: 'AnswerCallbackQuery',
  components:{
    Message
  },
  props: {
    data: Object
  },
  methods:{
  },


}
</script>
